import { render } from "./MMNoticeData.vue?vue&type=template&id=21a2c644"
import script from "./MMNoticeData.vue?vue&type=script&lang=js"
export * from "./MMNoticeData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__